<template>
  <v-data-table
    :items="migrations"
    :headers="headers"
    :items-per-page="itemsPerPage"
    @pagination="pagination"
    :page.sync="currentPage"
    :footer-props="{
      'items-per-page-options': itemsOptions,
    }"
    :height="migrationValidationTableHeigth"
    fixed-header
    item
  >
    <template v-slot:[`header.shared_with`]="{ header }">
      {{ header.text }}
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon color="grey" dark v-bind="attrs" v-on="on" small
            >ph-question</v-icon
          >
        </template>
        <span class="font-weight-medium">
          {{ $t("migrationTooltipMessage.sharedWith") }}
        </span>
      </v-tooltip>
    </template>
    <template v-slot:[`header.period`]="{ header }">
      {{ header.text }}
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon color="grey" dark v-bind="attrs" v-on="on" small
            >ph-question</v-icon
          >
        </template>
        <span class="font-weight-medium">
          {{ $t("migrationTooltipMessage.period") }}
        </span>
      </v-tooltip>
    </template>

    <template v-slot:[`item.source_email`]="{ item }">
      <Email
        :email="item.source_email.value"
        :code="item.source_email.code"
        :header="'source_email'"
      />
    </template>

    <template v-slot:[`item.target_email`]="{ item }">
      <Email
        :email="item.target_email.value"
        :code="item.target_email.code"
        :header="'target_email'"
      />
    </template>

    <!-- TODO: campos de drive -->
    <!-- <template v-slot:[`item.target_drive_email`]="{ item }">
      <Email
        :email="item.target_drive_email.value"
        :code="item.target_drive_email.code"
        :header="'target_drive_email'"
      />
    </template>-->

    <template v-slot:[`item.shared_with`]="{ item }">
      <div class="d-flex flex-column py-2">
        <div
          v-for="(shared, index) in item.shared_with"
          :key="shared.value + index"
          class="d-flex"
        >
          <Email
            :email="shared.value"
            :code="shared.code"
            :header="'shared_with'"
          />
        </div>
      </div>
    </template>

    <template v-slot:[`item.period`]="{ item }">
      <Period :date="item.period.value" :code="item.period.code" />
    </template>
  </v-data-table>
</template>

<script>
import Email from "@/components/migration/cells/Email.vue";
import Period from "@/components/migration/cells/Period.vue";
import { labels } from "@/helpers/variables/migrations";
import {
  migrationValidationTableHeigth,
  paging,
} from "@/helpers/variables/tablesDefault";

export default {
  name: "MigrationsValidationTable",

  components: {
    Email,
    Period,
  },
  props: {
    migrations: { type: Array },
  },
  data() {
    return {
      migrationValidationTableHeigth,
      currentPage: 1,
      itemsPerPage: paging.perPage,
      itemsOptions: paging.All,
    };
  },
  computed: {
    headers() {
      // retirar/editar essa porcentagem quando houver os campos de drive e compartilhamentos
      const col = "33.33%";
      return [
        {
          value: "source_email",
          text: labels.source_email,
          align: "start",
          width: col,
          sortable: false,
        },
        {
          value: "target_email",
          text: labels.target_email,
          align: "start",
          width: col,
          sortable: false,
        },
        // TODO: campos de drive
        // {
        //   value: "target_drive_email",
        //   text: labels.target_drive_email,
        //   sortable: false,
        //   align: "start",
        // },
        {
          value: "shared_with",
          text: labels.shared_with,
          sortable: false,
          align: "start",
        },
        {
          value: "period",
          text: labels.period,
          align: "start",
          width: col,
          sortable: false,
        },
      ];
    },
  },
  methods: {
    pagination(event) {
      this.currentPage = event.page;
    },
  },
};
</script>
